export const calculateStep = (clubSignup) => {
  let step = 'customer';
  if (clubSignup.data) {
    if (
      step === 'customer' &&
      (clubSignup.data.email || clubSignup.data.customerId) &&
      (clubSignup.data.shipTo ||
        clubSignup.data.orderDeliveryMethod === 'Pickup')
    ) {
      step = 'payment';
    }
    if (
      step === 'payment' &&
      clubSignup.data.billTo &&
      clubSignup.data.creditCard
    ) {
      if (clubSignup.data.customer) {
        step = 'complete';
      } else {
        step = 'account';
      }
    }
  }
  return step;
};

export const stepArray = ['customer', 'payment', 'account', 'complete'];

export const editStep = (clubSignup, step) => {
  const currentStep = calculateStep(clubSignup);
  const currentStepPosition = stepArray.indexOf(currentStep);
  const newStepPosition = stepArray.indexOf(step);
  if (currentStepPosition < newStepPosition) {
    return currentStep;
  }
  return step;
};
